import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GridExampleComponent } from './components/grid-example/grid-example.component';
import { ReorderGripComponent } from './components/reorder-grip/reorder-grip.component';
import { ResizeGripComponent } from './components/resize-grip/resize-grip.component';
import { TuGridModule } from 'toolbox-lib/packages/component-library/dist';

@NgModule({
  declarations: [
    AppComponent,
    GridExampleComponent,
    ReorderGripComponent,
    ResizeGripComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TuGridModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
